import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const delegateSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getDelegateHistory: builder.query({
            query: (arg: any) => {
                const { employeenumber, isDelegateTo } = arg;
                return {
                    url: constants.DELEGATE_HISTORY,
                    params: { employeenumber, isDelegateTo },
                };
            },
            providesTags: ['Delegates'],
            // keepUnusedDataFor:0,
        }),
        createDelegate: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_DELEGATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Delegates'],
        }),
        deactivateDelegate: builder.mutation({
            query: (arg: any) => ({
                url: constants.DEACTIVATE_DELEGATE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Delegates'],
        }),

        getAssociateDelegate: builder.query({
            query: (arg: any) => {
                const { employeenumber, delegatenumber } = arg;
                return {
                    url: constants.DELEGATE_ASSOCIATE_SEARCH,
                    params: { employeenumber, delegatenumber },
                };
            },
        }),
    }),
});

export const {
    useGetDelegateHistoryQuery,
    useCreateDelegateMutation,
    useDeactivateDelegateMutation,
    useGetAssociateDelegateQuery,
} = delegateSlice;
